import React from 'react';
import { Button, Modal } from 'antd';
import { confirmCloseEditing } from '../popup/confirm';
const confirm = Modal.confirm;

const BtnCloseEditing = ({ handleClick }) => {
  const confirmShow = () => {
    confirm({
      ...confirmCloseEditing,
      onOk: handleClick,
    });
  };

  return (
    <Button
      className="add-employee__reset"
      onClick={confirmShow}
      type="danger"
      size="large"
    >
      Отмена
    </Button>
  );
};

export default BtnCloseEditing;
